import MatestackUiVueJs from "matestack-ui-vuejs";

// Sidecar for Web::Components::ThemePicker. Posts the chosen slug to /theme
// (which sets the cookie), then flips <html data-theme> so the change is
// instant. Matestack swaps page DOM on transitions, so listeners are removed
// in beforeUnmount.
const themePicker = {
  mixins: [MatestackUiVueJs.componentMixin],
  template: MatestackUiVueJs.componentHelpers.inlineTemplate,
  data() {
    return { menuOpen: false, error: false, currentSlug: null, ready: false };
  },
  computed: {
    themes() {
      return this.props["themes"] || [];
    },
    current() {
      return this.themes.find((t) => t.slug === this.currentSlug) || null;
    },
  },
  mounted() {
    this.currentSlug = document.documentElement.dataset.theme || null;
    this.ready = true;
    this.onDocClick = (e) => {
      if (this.menuOpen && !e.target.closest("[data-theme-picker]")) this.closeMenu();
    };
    this.onKey = (e) => {
      if (e.key === "Escape" && this.menuOpen) this.closeMenu({ focus: true });
    };
    document.addEventListener("click", this.onDocClick);
    document.addEventListener("keydown", this.onKey);
  },
  beforeUnmount() {
    document.removeEventListener("click", this.onDocClick);
    document.removeEventListener("keydown", this.onKey);
  },
  methods: {
    toggleMenu() {
      this.menuOpen = !this.menuOpen;
      this.error = false;
    },
    closeMenu({ focus = false } = {}) {
      this.menuOpen = false;
      if (focus) this.trigger()?.focus();
    },
    trigger() {
      return this.getTemplateElement()?.querySelector("[data-theme-trigger]");
    },
    async choose(theme) {
      const token = document.querySelector("meta[name='csrf-token']")?.content;
      try {
        const response = await fetch("/theme", {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json", "X-CSRF-Token": token || "" },
          body: JSON.stringify({ slug: theme.slug }),
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        document.documentElement.dataset.theme = theme.slug;
        this.currentSlug = theme.slug;
        this.error = false;
        this.closeMenu({ focus: true });
      } catch (e) {
        this.error = true;
      }
    },
  },
};

export default themePicker;
